import {
  SaiDashboardEmbedUrlErrorCode,
  SaiDashboardType,
  useGetSaiDashboardEmbedUrlQuery,
} from '../../../graphQL';

const GENERIC_ERROR_MESSAGE = 'There was an error, please try again later.';

type UseGetEmbedUrlResult =
  | { status: 'loading' }
  | { status: 'error'; errorMessage: string; errorCode: SaiDashboardEmbedUrlErrorCode | null }
  | { status: 'success'; embedUrl: string };

type UseGetEmbedUrlParams = {
  dashboardKey: SaiDashboardType;
  orgId?: number | undefined;
};

export const useGetEmbedUrl = ({
  dashboardKey,
  orgId,
}: UseGetEmbedUrlParams): UseGetEmbedUrlResult => {
  const { data, loading, error } = useGetSaiDashboardEmbedUrlQuery({
    variables: {
      dashboardType: dashboardKey,
      orgId,
    },
  });

  if (loading) {
    return { status: 'loading' };
  }

  if (error) {
    return { status: 'error', errorMessage: error.message, errorCode: null };
  }

  const result = data?.getSaiDashboardEmbedUrl;

  if (!result || result.__typename !== 'SaiDashboardEmbedUrl') {
    const errorResult = result?.__typename === 'SaiDashboardEmbedUrlError' ? result : null;

    return {
      status: 'error',
      errorMessage: errorResult?.message ?? GENERIC_ERROR_MESSAGE,
      errorCode: errorResult?.errorCode ?? null,
    };
  }

  return { status: 'success', embedUrl: result.url };
};
